import * as z from 'zod';

export const useCreateBookmarkByUrlSchema = () => {
  return z.object({
    url: z.url()
  });
};
